import { z } from "zod"

/** Validated `/settings/users` search params. */
export const membersSettingsSearchSchema = z.object({
  q: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.string().min(1).max(200).optional(),
  ),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  offset: z.coerce.number().int().min(0).default(0),
  sort: z.string().default("created_at.desc"),
  // Optional (no default) so absent = the backend's active-only default and the URL stays clean.
  status: z.enum(["active", "inactive", "all"]).optional(),
})

export type MembersSettingsSearch = z.infer<typeof membersSettingsSearchSchema>

export const defaultMembersSettingsSearch: MembersSettingsSearch = membersSettingsSearchSchema.parse({})
